import { ResizeObserver as ResizeObserverPolyfill } from './resizeobserver.js';

export default () => {
  if (typeof window.ResizeObserver !== 'undefined') {
    return window.ResizeObserver;
  }

  return ResizeObserverPolyfill;
};
